// app/javascript/controllers/calendar_controller.js
import { Controller } from "@hotwired/stimulus"

const EMBED_SRC = "https://book.zoreal.com/embed.js"
const DEFAULT_LINK = "bynn/miz-ewbs"

// Opens a ZOREAL Book event type in a layer over the dashboard.
//
// The embed script is loaded once per page in popup mode, and from then on any
// element carrying data-zoreal-book-link opens the booking screens when it is
// clicked: the script's own delegated listener handles the click, so no action
// is wired here. The controller's job is to put that attribute, and the prefill
// the view passes as the config value, on every button target.
//
// The link is <handle>/<slug> of the event type on book.zoreal.com.
export default class extends Controller {
  static targets = ["button"]
  static values = {
    link: String,
    config: Object
  }

  connect() {
    this.ensureScript()
  }

  buttonTargetConnected(button) {
    button.setAttribute("data-zoreal-book-link", this.link)
    if (this.hasConfigValue && Object.keys(this.configValue).length > 0) {
      button.setAttribute("data-zoreal-book-config", JSON.stringify(this.configValue))
    }
  }

  get link() {
    return this.linkValue || DEFAULT_LINK
  }

  ensureScript() {
    if (document.querySelector(`script[src="${EMBED_SRC}"]`)) return

    const script = document.createElement("script")
    script.src = EMBED_SRC
    script.async = true
    script.setAttribute("data-zoreal-book", this.link)
    script.setAttribute("data-zoreal-book-mode", "popup")
    document.head.appendChild(script)
  }
}
